import { Injectable } from '@angular/core';
import * as sha256 from "fast-sha256";
import encodeUtf8 from 'encode-utf8';
import { FirebaseProvider } from '../firebase/firebase';
import { tableNames } from '../../app/app.constants';
import { GlobalVars } from '../../app/app.environment';
import { QueryModel } from '../../models/query';

@Injectable()
export class CodeProvider {

  constructor(
    public firebaseService: FirebaseProvider,
    public globalVars: GlobalVars,
  ) {}

  isAvailable(key: string) {
    let hashKey = this.doHash(key);

    return new Promise(resolve => {
      let query = new QueryModel();
      
      query.orderByChild = 'key';
      query.equalTo = hashKey;
  
      this.firebaseService.list(this.getBaseRoot(), query).subscribe(result => {
        if(result.length > 0) resolve(false)
        else resolve(true)
      })
    })
  }

  saveKey(userId: string, key: string) {
    return this.firebaseService.set(this.getBaseRoot(), userId, { key: this.doHash(key), userId: userId });
  }

  getUserByKey(key: string) {
    let hashKey = this.doHash(key);

    return new Promise(resolve => {
      let query = new QueryModel();
      
      query.orderByChild = 'key';
      query.equalTo = hashKey;
  
      this.firebaseService.list(this.getBaseRoot(), query).subscribe(result => {
        if(result.length > 0) resolve(result[0].userId)
        else resolve(false)
      })
    })
  }

  private doHash(data: string): string {
    let hash = sha256.hash(new Uint8Array(encodeUtf8(data)))
    return hash.toString();
  }

  /**
   * Arrel base dins la base de dades.
   */
  private getBaseRoot(): string {
    return tableNames.Repo + '/' + this.globalVars.user.repo + '/' + tableNames.Keys + '/';
  }
}



// WEBPACK FOOTER //
// ./src/providers/code/code.ts